import { render } from "./ReexamePDF.vue?vue&type=template&id=6fb7b998&ts=true"
import script from "./ReexamePDF.vue?vue&type=script&lang=ts"
export * from "./ReexamePDF.vue?vue&type=script&lang=ts"

import "./ReexamePDF.vue?vue&type=style&index=0&id=6fb7b998&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__